import React from 'react'
import './GetInTouch.css'
import flower2 from '../../Assets/flower2.svg'
function GetInTouch() {
    return (
        <div>
        <div className="get-in-touch">
            <a href="mailto: alioth840@gmail.com"><h1>Get In Touch!</h1></a>
            <p>Let's share ideas and discuss future projects over a cup of coffee. I’d love to hear from you!






</p>
            <img src={flower2} alt="" />
        </div>
        </div>
    )
}

export default GetInTouch
